/* eslint-disable prefer-regex-literals */
export const getRegExArray = (input: string | Array<string> | Array<RegExp>): Array<RegExp> => {
	if (typeof input === 'string') {
		return input === '*' ? [new RegExp('^.*$', 'su')] : [new RegExp(`^${input}$`, 'u')];
	} else if (input instanceof RegExp) {
		return [input];
	} else if (Array.isArray(input)) {
		const ra = input.map((inputEntry) => {
			if (typeof inputEntry === 'string') {
				return inputEntry === '*' ? new RegExp('^.*$', 'su') : new RegExp(`^${inputEntry}$`, 'u');
			} else if (input instanceof RegExp) {
				return inputEntry;
			}

			return null;
		}).filter((inputEntry) => inputEntry !== null);
		return ra;
	}

	return [];
};
